<template>
	<section class="itv-filters">
		<h2 class="itv-filters__title">{{ title }}</h2>
		<div class="itv-filters__wrapper">
			<template v-for="item in fields" :key="item.id">
				<div v-if="item.type === 'checkbox'" class="itv-filters__field-wrap">
					<input-checkbox
						class="itv-filters__field"
						:id="item.id"
						:label="item.label"
						:name="item.name"
						@change-event="fieldHandler"
					/>
				</div>
				<div v-if="item.type === 'select'" class="itv-filters__field-wrap">
					<template v-if="item.list.length > 0">
						<simple-select
							class="itv-filters__field"
							:id="item.id"
							:list="item.list"
							:placeholder="item.placeholder"
							:label="item.label"
							:name="item.name"
							@change-value="fieldHandler"
						/>
					</template>
				</div>
			</template>
			<div class="itv-filters__field-wrap">
				<primary-button
					class="itv-filters__btn"
					:content="button"
					@click-event="resetFilters"
				>
					<template #icon-left>
						<div class="itv-filters__icon">
							<svg
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M12.1881 3C7.096 3 3 7.04692 3 12C3 16.9531 7.096 21 12.1881 21C16.4136 21 19.9598 18.209 21.0383 14.4275C21.1898 13.8963 21.7432 13.5886 22.2743 13.7401C22.8054 13.8916 23.1131 14.4449 22.9617 14.976C21.6385 19.6152 17.3084 23 12.1881 23C6.02673 23 1 18.0926 1 12C1 5.90738 6.02673 1 12.1881 1C16.0742 1 19.5033 2.94936 21.5097 5.91487L22.04 4.0966C22.1946 3.56641 22.7498 3.26195 23.28 3.41658C23.8102 3.57121 24.1146 4.12638 23.96 4.65657L22.7184 8.9137C22.6442 9.1683 22.4718 9.38299 22.2393 9.51052C22.0067 9.63804 21.733 9.66797 21.4784 9.59372L17.182 8.34066C16.6518 8.18603 16.3473 7.63087 16.502 7.10068C16.6566 6.57048 17.2118 6.26602 17.742 6.42066L19.8539 7.03661C18.2109 4.60709 15.3941 3 12.1881 3Z"
									fill="white"
								/>
							</svg>
						</div>
					</template>
				</primary-button>
			</div>
		</div>
	</section>
</template>

<script>
import SimpleSelect from '../ui/SimpleSelect'
import InputCheckbox from '../ui/InputCheckbox'
import PrimaryButton from '../ui/PrimaryButton'

export default {
	name: 'Filters',
	components: {
		SimpleSelect,
		InputCheckbox,
		PrimaryButton,
	},
	props: {
		content: {
			type: Object,
			default: () => {},
		},
	},
	watch: {
		content: {
			handler(newVal) {
				this.createFilterList(newVal)
			},
			deep: true,
		},
	},
	data() {
		return {
			title: 'Фильтры',
			fields: [],
			button: {
				btnColorType: 'black',
				text: 'Сбросить фильтры',
			},
		}
	},
	methods: {
		fieldHandler(val, id) {
			this.$emit('change-event', val, id)
		},

		resetFilters() {
			this.$emit('change-event', '', 'reset')
		},

		createFilterList(content) {
			this.fields = []
			Object.entries(content).forEach(el => {
				if (el[0] === 'intern') {
					this.createField(el[1], 'checkbox', el[0])
					return
				}

				this.createField(el[1], 'select', el[0])
			})

			this.$emit(
				'updateFields',
				this.fields.map(el => el.id)
			)
		},

		createField(el, type, paramName) {
			let label

			if (type === 'checkbox') {
				label = el.values[0].title
			}

			const element = {
				id: paramName,
				type: type,
				list: el.values,
				label: label,
				placeholder: el.title,
				name: `form[${paramName}]`,
			}

			this.fields.push(element)
		},
	},
	created() {
		this.createFilterList(this.content)
	},
}
</script>
